module.exports = __webpack_public_path__ + "static/media/flag-sr.0dc67640.webp";